import { createStyles, Accordion, Group, rem, Container, Title, Box } from '@mantine/core';

const useStyles = createStyles((theme) => ({
    wrapper: {
        paddingTop: `calc(${theme.spacing.xl} * 2)`,
        paddingBottom: `calc(${theme.spacing.xl} * 2)`,
    },

    title: {
        [theme.fn.smallerThan('sm')]: {
            fontSize: rem(24),
            maxWidth: '100%',
        },
        maxWidth: '66%',
    },

    item: {
        fontSize: theme.fontSizes.sm,
        backgroundColor: theme.colorScheme === 'dark' ? "#FFF5F9" : "#FFF5F9",
    },
}));

const placeholder =
    'It can’t help but hear a pin drop from over half a mile away, so it lives deep in the mountains where there aren’t many people or Pokémon.';

const mockdata = [
    {
        question: {
            '/': 'Why does ResiRent use a subscription model?',
            '/nl': 'Waarom hanteert ResiRent een abonnementen formule?',
            '/de': 'Warum verwendet ResiRent ein Abonnementmodell?',
        },
        answer: {
            '/': 'ResiRent provides service throughout the year to address issues, takes care of website hosting, and continuously works on improvements based on customer feedback.',
            '/nl': 'ResiRent biedt een service gedurende het jaar bij problemen, neemt de hosting van de website voor haar rekening en werkt continu aan verbeteringen op basis van feedback van de klanten.',
            '/de': 'ResiRent bietet das ganze Jahr über Service zur Lösung von Problemen, kümmert sich um das Hosting der Website und arbeitet kontinuierlich an Verbesserungen auf der Grundlage des Kundenfeedbacks.',
        },
    },
    {
        question: {
            '/': 'Do I need a domain name to start the 28-day free trial?',
            '/nl': 'Heb ik een domeinnaam nodig om de gratis proefperiode van 28 dagen te starten?',
            '/de': 'Brauche ich einen Domainnamen, um die 28-tägige kostenlose Testphase zu starten?',
        },
        answer: {
            '/': 'Nope! You can jump right in and start building your website using our demo version — no domain name required. Once your trial ends (and hopefully you’re loving what you’ve built!), we’ll help you register a new domain name or migrate your existing one to our server. Easy and hassle-free!',
            '/nl': 'Nee hoor! Je kan meteen aan de slag met het bouwen van je website via onze demo-versie — geen domeinnaam nodig. Na die 28 dagen hopen we natuurlijk dat je helemaal enthousiast bent. Dan helpen we je graag bij het aankopen van een domeinnaam of het verhuizen van je bestaande domein naar onze server. Simpel en stressvrij!',
            '/de': 'Nein, das ist nicht nötig! Du kannst sofort loslegen und deine Website mit unserer Demoversion erstellen – ganz ohne Domainnamen. Wenn deine Testphase endet (und du hoffentlich begeistert bist von dem, was du gebaut hast!), helfen wir dir gerne dabei, einen neuen Domainnamen zu registrieren oder deine bestehende Domain auf unseren Server zu übertragen. Einfach und stressfrei!',
        },
    },
    {
        question: {
            '/': 'Who owns the domain name?',
            '/nl': 'Wie is eigenaar van de domeinnaam?',
            '/de': 'Wer ist Eigentümer des Domainnamens?',
        },
        answer: {
            '/': 'You own the domain name, as the owner and/or operator of the accommodation.',
            '/nl': 'Dat ben jij, eigenaar en/of uitbater van de accommodatie.',
            '/de': 'Das sind Sie, als Eigentümer und/oder Betreiber der Unterkunft.',
        },
    },
    {
        question: {
            '/': 'Subscription Cancellation Notice?',
            '/nl': 'Opzegtermijn Abonnement?',
            '/de': 'Kündigungsfrist Abonnement?',
        },
        answer: {
            '/': 'The subscription is cancelable annually. We will send you a request to renew one month before the expiration date. If you cancel the subscription, you will lose access to the website builder. You will retain your own domain name and will be responsible for its management and payment.',
            '/nl': 'Het Abonnement is jaarlijks opzegbaar. Wij sturen je 1 maand voor de vervaldatum de vraag of u nog verder geabonneerd wenst te blijven. Als je het abonnement opzegt, heb je geen toegang meer tot de websitebouwer. Je behoudt je eigen domeinnaam en zal dan voor het beheer en de betaling zelf instaan.',
            '/de': 'Das Abonnement ist jährlich kündbar. Wir senden Ihnen einen Monat vor dem Ablaufdatum eine Anfrage zur Verlängerung. Wenn Sie das Abonnement kündigen, verlieren Sie den Zugriff auf den Website-Builder. Sie behalten Ihren eigenen Domainnamen und sind für dessen Verwaltung und Zahlung verantwortlich.',
        },
    },
];

export function FAQ() {
    const languagePrefix = window.location.pathname.startsWith('/nl') ? '/nl' : window.location.pathname.startsWith('/de') ? '/de' : '/';
    const { classes } = useStyles();
    return (
        <div className={classes.wrapper}>
            <Container size="lg">
                <Group position="center">
                    <Title mb="md" order={2} className={classes.title} ta="center">
                        Frequently Asked Questions
                    </Title>
                </Group>

                <Box m="md">
                    <Accordion defaultValue="" chevronPosition="right" variant="separated">
                        {mockdata.map((feature) => (
                            <Accordion.Item key={feature.question[languagePrefix]} value={feature.question[languagePrefix]} className={classes.item}>
                                <Accordion.Control> {feature.question[languagePrefix]}</Accordion.Control>
                                <Accordion.Panel>{feature.answer[languagePrefix]}</Accordion.Panel>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </Box>
            </Container>
        </div>
    );
}